import type { DisplayStatus, ITaskCard } from './types';

export const PRIORITY_COLOR: Record<ITaskCard['priority'], string> = {
  high: 'red',
  medium: 'orange',
  low: 'blue',
};

export const STATUS_COLOR_CLASS: Record<DisplayStatus, string> = {
  open: 'status-open',
  assigned_to_me: 'status-assigned-to-me',
  assigned_to_other: 'status-assigned-to-other',
  completed: 'status-completed',
};

/** Polling interval (ms) for task list refresh when the drawer is open. */
export const TASK_POLLING_INTERVAL_MS = 5000;
